module.exports = __webpack_public_path__ + "img/floppy-green-full.33284c02.svg";